import ButtonGroup from '@zenbusiness/zui/ButtonGroup';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const StyledButtonGroup = superstyled({
  name: 'StyledButtonGroup',
  slot: 'Root',
  tag: ButtonGroup,
  styles: ({ disabled }) => ({
    display: 'flex',
    justifyContent: 'left',
    ...(disabled && {
      '&& .MuiButtonGroup-grouped:not(:last-of-type)': {
        borderRight: 'none'
      }
    })
  })
});
